import { render, staticRenderFns } from "./LegacyForm.vue?vue&type=template&id=f4a99752&scoped=true"
import script from "./LegacyForm.vue?vue&type=script&lang=js"
export * from "./LegacyForm.vue?vue&type=script&lang=js"
import style0 from "./LegacyForm.vue?vue&type=style&index=0&id=f4a99752&prod&lang=scss&scoped=true"
import style1 from "./LegacyForm.vue?vue&type=style&index=1&id=f4a99752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a99752",
  null
  
)

export default component.exports